export default __webpack_public_path__ + "static/media/card1@2x.5cad7349.png";